module.exports = __webpack_public_path__ + "static/splatoon-a-245055f1a6c03b0144c2f6d85fcb5dc8.png";